import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Container, ButtonToolbar, ButtonGroup, Row, Button } from "react-bootstrap";
import FuseModal from "./modals/FuseModal";
import DataTable from "react-data-table-component";
import PropTypes, { element } from "prop-types";
import FuseInputBox from "./inputFields/FuseInputBox";
import { ToastTypes } from "./modals/FuseToast";
import { addToastAction } from "../../actions/generic/toastActions";
import { showDataFetchError } from "../../actions/generic/fuseAlerts";
import { newAttachment, getAttachmentList, getAttachment, getAttachmentDownloadUrl, getMaxAttachmentSizeAndMbByteCount,
         updateAttachment, addAttachment, deleteAttachment, requiresAttachment, downloadFromUrl_GET } from "../../webservices/generic/attachmentsWs";
import { updateRecord } from "../../webservices/generic/genericDataWs";
import { ContinuousSizeLegend } from "react-vis";
import { ThemeProvider } from "styled-components";
import FileSaver from 'file-saver';

class FuseAttachment extends React.Component {
  constructor(props) {
    super(props);
    
    this._isMounted = false;
    this.state = {
        open: false,
        required: null,
        isDirty: false,
        data: [],
        origionalData: [],
        other: null,
        sourceKey: null
    };
    
  }

  static defaultProps = {  
    open: false
  };

  componentDidMount(){    
    this._isMounted = true;
    if(!_.isEmpty(this.props.tableName) && this._isMounted )
      this.checkIfAttachentRequired(this.props.tableName, this.props.sourceKey);    
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onAddNewAttachment = () => {
    var data = [...this.state.data];
    var newRecord = { "attachmentType":"Other", "contentType":null, "mime": "*.pdf,*.doc,*.docx,*.xls,*.xlsx,*.csv", "required":true, "name":"", "description":"", "file": null, "inserted": true, "tableName":this.props.tableName};

    this.setState({data: [...data,newRecord] });
  };

  onSaveAttachments = () =>{
    var inserted = this.state.data.filter((attachment)=> attachment.inserted === true && attachment.file !== null);

    var edited = this.state.data.filter((attachment)=> attachment.inserted !== true && attachment.isEdited === true);
    
    var deleted = this.state.data.filter((attachment)=> attachment.isDeleted === true);
    inserted.forEach((attachment) => {
      this.saveAttachment(this.state.sourceKey, attachment.file.type, attachment.file.name,  attachment.description, attachment.attachmentType, attachment.file, attachment.tableName);
     });

    edited.forEach((attachment) => {
      this.updateCurrentAttachment(attachment.description,  attachment.documentNumber, attachment.id,  attachment.name, attachment.sourceKey);
      });
    
    deleted.forEach((attachment) => {
        this.removeAttachment(attachment.id,   attachment.sourceKey);
      });

    this.fetchAttachmentList(this.state.sourceKey);
    this.closeModal();
  }

  onCancel = () => {
    var origionalData = this.state.origionalData;
    this.setState({open: false, data: [...origionalData]});
  }

  closeModal = ()=>{
    this.setState({open:false});  
  };

  buildFileTable=()=>{
    const minWidthForCol = (type) => {
      const medium = "200px";
      const large = "300px";
      const xlarge = "400px";
      const normal = "170px";
      const small = "100px";
      const xsmall = "50px";
      const action = "200px";
  
      switch (type.toLowerCase()) {
        case "action":
          return action;
        case "bool":
          return small;
        case "text-large":
          return large;
        case "text":
          return small;
        case "action-validate":
          return small;
        default:
          return normal;
      }
    };
  
    const maxWidthForCol = (type) => {
      const medium = "600px";
      const large = "900px";
      const xlarge = "1200px";
      const normal = "500px";
      const small = "300px";
      const xsmall = "150px";
      const action = "200px";
  
      switch (type.toLowerCase()) {
        case "action":
          return action;
        case "bool":
          return small;
        case "text-large":
          return medium;
        case "text":
          return small;
        case "action-validate":
          return small;
        default:
          return normal;
      }
    };

    
    const createDataTableColumn = (col) => {
      return {
        name: col.name,
        selector: col.selector,
        sortable: true,
        minWidth: minWidthForCol(col.columnType),
        maxWidth: maxWidthForCol(col.columnType),
        width: minWidthForCol(col.columnType),
        cellExport: (row) => row[col.selector],
        cell: (row, index, column) => {
          let key = `${row[col.selector]}_${col.name}_${index}_${JSON.stringify(row)}`;
          if(col.columnType === "bool"){
            return ( row[col.selector] === false || row[col.selector] === false ) ? <i className="fa fa-times" aria-hidden="true"></i> : <i className="fa fa-check" aria-hidden="true"></i>;
          }
          return <FuseInputBox
            key={key}
            id={key}
            name={col.selector}
            required={!col.nullable}
            type={col.columnType}
            value={row[col.selector]}
            editable={col.editable}
            onChange={(val)=>{
              row[col.selector] = val;
              row.isEdited = true;
              this.state.isDirty = true;
            }}
          />;
        },
      };
    };  

    const conditionalRowStyles = [
      {
        when: (row) =>
          !_.isEmpty(this.state.selectedRow) &&
          row.id === this.state.selectedRow.id,
        style: {
          backgroundColor: "#e3f2fd", //Todo: This should use bootstrap colours. But how???
        },
      },
      {
        when: (row) => row.isDeleted === true,
        style: {
          backgroundColor: "red", //Todo: This should use bootstrap colours. But how???
        },
      },
    ];
      
    var columns = Columns.map(createDataTableColumn);
      
      columns.unshift({
        name: "",
        text: "",
        columnType: "action-validate",
        // className: "d-flex",
        cell: (row, index, column) => {
          let key = `fp${index}`;
          return (<div  key={key}>
            <ButtonToolbar aria-label="Toolbar with button groups">
              {this.props.isInEdit  && !row.isDeleted  && row.inserted && <>
                <Button id={key} key={key}
                    className="mr-1 shadow-sm"
                    variant="light">
                      {/* <FuseInputBox type="file"></FuseInputBox> */}
                  <FuseInputBox
                        id={key}
                        type="file"
                        className={"flex"}
                        accept={this.handleExtensions(row["mime"])}
                        // maxSize={50}
                        // extensions= {["application/docx","image/png"]}///{row["contentType"] === null ? null : row["contentType"]}
                        onChange={(doc) =>{ 
                          row["file"] = doc; 
                          row["name"] = doc.name;
                          row["inserted"] = true;
                          this.setState({isDirty:true});
                        }}
                        onError={error => { 
                          this.props.addToast(ToastTypes.ERROR,error);
                        }}
                        onClear={() => this.setState({ file: {} })}
                        triggerReset={this.state.reset}
                    ><i className="fa fa-upload" /> 
                  </FuseInputBox> 
                </Button>  
              </>}           

              { this.props.isInEdit && !row.inserted && !row.isDeleted && <>
                <Button
                  className="mr-1 shadow-sm"
                  variant="danger"
                  onClick={()=>{
                    row.isDeleted = true;
                    this.setState({isDirty: true});
                  /*this.onDeleteAttachment(row);*/}}
                >
                  <i className="fa fa-trash" />
                </Button>
              </>}
              {!row.inserted && <>
                <Button
                  className="mr-1 shadow-sm"
                  variant="light"
                  onClick={()=>{this.onDownloadAttachment(row);}}>
                  <i className="fa fa-download" />
                </Button>
              </>}
            </ButtonToolbar></div>
          );
      }});

      return <Container fluid>
            <Row className="align-middle">
                <DataTable
                    highlightOnHover={true}
                    columns={columns}
                    data={this.state.data}
                    dense={true}
                    noHeader={true}
                    // responsive={true}
                    striped={false}
                    theme="fuseDataTableTheme"
                    conditionalRowStyles={conditionalRowStyles}/>
            </Row>
            
            <br/>
            <ButtonToolbar
              className="justify-content-between"
              aria-label="Toolbar with Button groups"
            >
                <ButtonGroup >
                  {this.props.isInEdit && <>
                  <Button variant="success"
                      className="mr-1 shadow-sm"
                      onClick={this.onAddNewAttachment}>Add Another Attachment</Button>
                      </>}
                </ButtonGroup>
                <ButtonGroup >
                  <Button variant="info"
                      className="mr-1 shadow-sm"
                      onClick={this.onSaveAttachments}>Ok</Button>
                  <Button variant="danger"
                      className="mr-1 shadow-sm"
                      onClick={this.onCancel}>Cancel</Button>
                </ButtonGroup>
            </ButtonToolbar>
    </Container>;
  } 
  
  handleExtensions = (accepts) =>{    
    var modded = accepts.toString().replace("*.",".");
    if(modded.includes("*.")){
      return this.handleExtensions(modded);
    }else{
      if(modded === ".*")
        return null;
      return modded;
    }
  }
 
  showFuseAttachmentPickerModal = () => {
    return (
      <FuseModal
        isShowing={this.state.open}
        onClose={this.closeModal}
        sizeString="xl"
        icon='add'
        title="Linked Attachment">
        {this.buildFileTable()}
      </FuseModal>
    );
  }

  render() {
    return (
      <div className="d-flex">
        {!this.props.showAsButton ?
          <span className="fuse-validation-button-wrapped">
            {this.state.required === true ? <i className="fa fa-paperclip required-attachment" aria-hidden="true" onClick={this.showFilePickerTable}>!</i>
              : <i className="fa fa-paperclip" aria-hidden="true" onClick={this.showFilePickerTable}></i>}
            {this.props.requiresValidation &&
              <input id="attachmentButton" className="validation-input-disabled-hidden" value={this.state.required ? "" : "Assigned"} onChange={(val) => { }} required />
            }
          </span> :
          <Button
            variant="light"
            className="mr-1 shadow-sm"
            hidden={this.props.hidden}
            disabled={this.props.disabled}
            onClick={this.showFilePickerTable}
          >
            <i className="fa fa-paperclip" aria-hidden="true" />
          </Button>
        }
        {this.state.open && this.showFuseAttachmentPickerModal()}
      </div>);
  }

  showFilePickerTable = () => {      
      this.setState({open:true});
      
      if(!_.isEmpty(this.props.sourceKey)){      
        this.fetchAttachmentList(this.props.sourceKey);
      }else if(!_.isEmpty(this.state.sourceKey)){
        this.fetchAttachmentList(this.state.sourceKey);
      }else{
        this.getNewAttachment();
      }
  }
  
  saveAttachment = (sourceKey, contentType, name, description, attType,  data, tableName) => {
    addAttachment(sourceKey, contentType, name, description, attType,  data, tableName)
      .then((response) => {
        console.log("RESPONSE: "+ JSON.stringify(response));
        if (!_.isEmpty(response.error)) {
          console.log("Error saving attachment data:");
        } else{
          console.log("Attachment saved");
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  updateCurrentAttachment = (description, documentNumber, id, name, sourceKey) => {
    updateAttachment(description, documentNumber, id, name, sourceKey).then(
      (response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error updating attachment data");
        }else{
          console.log("Attachment data updated");
        }
      }
    ).catch(function (error) {
      console.log("exception:" + error);
    });
  }

  onDeleteAttachment = (attachment) => {
    attachment.isDeleted = true;
    this.setState({isDirty:true});
  }

  
  onDownloadAttachment = (attachment) => {
	if(attachment != null){
		if(attachment?.downloadFromUrl == true){
			this.downloadAttachmentFromUrl(attachment.id, attachment.name, attachment.contentType, attachment.sourceKey);
		}else{
			this.downloadAttachment(attachment.id, attachment.name, attachment.contentType, attachment.sourceKey);
		}
	}
  }

  fetchAttachmentList = (sourceKey) => {
    getAttachmentList(sourceKey)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching attachment data");
          this.props.showDataFetchError("Error fetching attachments data");
        } else if (response.data.success === true) {
          var data = response.data.result;
            
          this.setState({ sourceKey: sourceKey});
          this.addRequiredAttachmentsAttachmentList(data);
        } else {
          this.props.showDataFetchError("Error fetching attachments data");
          console.log("Error fetching attachment data");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  addRequiredAttachmentsAttachmentList(attachments){
    if(_.isEmpty(this.props.tableAttachments)){
      this.setState({data: attachments});
    }else if(!_.isEmpty(this.props.tableAttachments)){
      console.log("Attachments");
      //add missing required fields
      var documents = [];
      this.props.tableAttachments.forEach((document) => {
        var attachment = {
          "attachmentType": document.att_type,
          "contentType": null,//
          "mime": document.att_mask,
          "required": document.required,
          "name": "",
          "description": "",
          "file": null,
          "marked" : false,
          "inserted" : true // Mark this as true on upload
        };
        documents.push(attachment);
      });

      var merged = [];
      attachments.forEach((attachment)=>{
        merged.push(attachment);
      });

      documents.forEach((document)=>{
        if(!attachments.some(
          (attachment)=> attachment.attachmentType.toString().toLowerCase() === document.attachmentType.toString().toLowerCase()
          )){
            if(document.required === true){
              merged.unshift(document);
            }else{
              merged.push(document);
            }
        }
      });

      attachments.forEach((attachment) => {
        documents.forEach((document) => {
          try{
            if(attachment.attachmentType.toString().toLowerCase() === document.attachmentType.toString().toLowerCase()){
              attachment.mime = document.mime;
              attachment.required = document.required;
              throw("Assigned");
            }
          }catch(onError){
          }
        });
      });

      documents = merged.length === 0 ? documents : merged;
      this.setState({data: [...documents]});    
      if(!_.isEmpty(this.props.tableName))
        this.checkIfAttachentRequired(this.props.tableName, _.isEmpty(this.props.sourceKey) ? this.state.sourceKey : this.props.sourceKey );
    }
  }
  
  getMaxAttachmentSizeAndMbByteCount = () => {
    getMaxAttachmentSizeAndMbByteCount()
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching attachment size and Mb byte count:");
        } else if (response.data.success === true) {
        } else {
          console.log("Error fetching attachment size and Mb byte coun:");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  getNewAttachment = () => {
    newAttachment()
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching attachment id:");
        } else if (response.data.success === true) {
          var key = response.data.result;
          console.log(key);
          this.setState({sourceKey: key, open:true});
          this.props.onUpdateSourceKey(key);
          this.addRequiredAttachmentsAttachmentList([]);     
        } else {
          console.log("Error fetching attachment id:");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  
  downloadAttachment = (id, name, type, sourceKey) => {
    getAttachment(id, name, sourceKey)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching attachment");
        } else if (response.data.success === true) {
          var binaryData = response.data.result;

          var b64toBlob = require('b64-to-blob');
          var blob = b64toBlob(binaryData, type);

          var FileSaver = require('file-saver');
          FileSaver.saveAs(blob, name);
        } else {
          console.log("Error fetching attachment");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  downloadAttachmentFromUrl = (id, name, type, sourceKey) => {
	getAttachmentDownloadUrl(id, name, sourceKey).then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching attachment download URL");
        } else if (response.data.success === true) {
          var jsonObject = response.data.result;
		  if(jsonObject?.downloadUrl != null){
			const downloadUrl = jsonObject.downloadUrl;
			FileSaver.saveAs(downloadUrl, name);
		  } else{
			console.log("Error fetching attachment download URL");
			console.log(JSON.stringify(response.data));
		  }
        } else {
          console.log("Error fetching attachment download URL");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:", error);
      });
  }

  checkIfAttachentRequired = (tableName, sourceKey) => {
    requiresAttachment(tableName, sourceKey)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error checking if attachments required");
        } else if (response.data.success === true) {
          var required = response.data.result;
          if(this._isMounted) this.setState( {required: required});
        } else {
          console.log("Error checking if attachments required");
          console.log(response.data);
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

  
  removeAttachment = (id, sourceKey) => {
    deleteAttachment(id, sourceKey)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error deleting attachment");
        } else if (response.data.success === true) {
          // var attachment = response.data.result;
          // console.log(attachment);
          // this.setState({sourceKey: key, open:true});
        } else {
          console.log("Error deleting attachment");
          console.log(JSON.stringify(response.data));
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
      });
  };

}

const Columns = [
    {
    "name":"Type",
    "editable":false,
    "selector":"attachmentType",
    "nullable": false,
    "columnType": "text"
    },
    { 
        "name":"Mask",
    "editable":false,
    "selector":"mime",
    "nullable": false,
    "columnType": "text"
    },
    {
        "name":"Required",
    "editable":false,
    "selector":"required",
    "nullable": true,
    "columnType": "bool"
    //Required has no type, if attachmentType != other then it is required 
    //All new files are not required
    },
    { 
        "name":"Name",
    "editable":true,
    "selector":"name",
    "nullable": true,
    "columnType": "text-large"
    },
    { 
        "name":"Description",
    "editable":true,
    "selector":"description",
    "nullable": true,
    "columnType": "text-large"
    }
];

FuseAttachment.propTypes = {};

const mapStateToProps = (state, ownProps) => {
  
  // sourceKey={null}
  // onUpdateSourceKey={(sourceKey) => {
  //     //update source key
  //   }
  // }
  // isInEdit={true}
    return {
    };
};

export default connect(
  mapStateToProps, 
  (dispatch, ownProps) => ({
    showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
    addToast: (type, text) => dispatch(addToastAction(type, text)),
    })
  )(FuseAttachment);